const translation = {
  // Navbar
  "nav.home": "首页",
  "nav.about": "关于我们",
  "nav.tours": "旅游套餐",
  "nav.gallery": "图库",
  "nav.testimonials": "客户评价",
  "nav.contact": "联系我们",
  "nav.bookNow": "立即预订",
  "nav.busTickets": "巴士票",
  "nav.certifications": "认证资质",

  // Hero
  "hero.slide1.headline": "探索世界",
  "hero.slide1.sub": "信心满满",
  "hero.slide1.tagline": "马来西亚自2008年以来信赖的旅游伙伴。为超过20,000名快乐旅行者打造非凡旅程。",
  "hero.slide2.headline": "发现亚洲",
  "hero.slide2.sub": "超越想象",
  "hero.slide2.tagline": "从日本的樱花到巴厘岛的庙宇 — 亚洲等待着您的到来。",
  "hero.slide3.headline": "梦想目的地",
  "hero.slide3.sub": "实惠价格",
  "hero.slide3.tagline": "从欧洲到马尔代夫，我们让您的梦想假期成为美好现实。",
  "hero.badge": "Arus Travel & Tours Sdn Bhd",
  "hero.cta.explore": "探索套餐",
  "hero.cta.bus": "预订巴士票",
  "hero.cta.contact": "联系我们",

  // Featured Tours
  "featured.badge": "精心为您挑选",
  "featured.title": "精选旅游套餐",
  "featured.subtitle": "探索我们最受欢迎、精心策划的旅程 — 每一段旅程都旨在创造终身难忘的记忆。",
  "featured.viewAll": "查看全部套餐",
  "featured.viewDetails": "查看详情",
  "featured.perPax": "/ 人",
  "featured.reviews": "条评价",

  // Popular Destinations
  "destinations.badge": "去哪里",
  "destinations.title": "热门目的地",
  "destinations.subtitle": "从热带天堂到文化奇迹 — 发现世界上最令人叹为观止的目的地。",
  "destinations.explore": "立即探索",
  "destinations.packages": "套餐",

  // Bus Ticketing
  "bus.badge": "城际快速巴士",
  "bus.title": "预订您的巴士票",
  "bus.titleHighlight": "快捷方便",
  "bus.description": "在马来西亚国内旅行？通过我们信赖的合作伙伴Easybook在线预订城际快速巴士票 — 覆盖半岛主要路线，持牌运营商服务。",
  "bus.bookNow": "立即预订巴士票",
  "bus.poweredBy": "巴士票务由我们的合作平台提供支持",
  "bus.f1.label": "城际路线",
  "bus.f1.desc": "吉隆坡、槟城、新山等",
  "bus.f2.label": "安全可靠",
  "bus.f2.desc": "仅限持牌运营商",
  "bus.f3.label": "即时预订",
  "bus.f3.desc": "几秒内获得电子票",
  "bus.f4.label": "最优惠票价",
  "bus.f4.desc": "无隐藏费用",

  // Why Choose Us
  "why.badge": "我们的承诺",
  "why.title": "为何选择Arus Travel？",
  "why.subtitle": "我们不仅仅是订机票和酒店 — 我们打造让您永久珍藏的旅行体验。",
  "why.r1.title": "持牌信赖",
  "why.r1.desc": "获马来西亚旅游部（MOT）全面授权，并荣幸成为MATTA及IATA会员。您的安全与满意是我们的首要任务。",
  "why.r2.title": "全天候支持",
  "why.r2.desc": "我们专业的旅游顾问全天候待命，在旅行前、旅行中及旅行后为您提供协助。",
  "why.r3.title": "最优惠价格保证",
  "why.r3.desc": "我们与航空公司和酒店协商最优惠的价格，让您物超所值 — 绝无隐藏费用。",
  "why.r4.title": "量身定制行程",
  "why.r4.desc": "我们为您打造的每一段旅程都根据您的喜好、旅行风格和预算量身定制 — 从个人游到大型团体游。",
  "why.r5.title": "专业本地导游",
  "why.r5.desc": "我们的经验丰富、多语言本地导游网络，以真实的文化见解丰富您的旅行体验。",
  "why.r6.title": "20,000+快乐旅行者",
  "why.r6.desc": "超过17年的经验和数千名满意客户 — 我们在所有平台上均获得4.9/5星的骄人评分。",

  // Stats
  "stats.badge": "我们的成绩",
  "stats.title": "二十年旅游卓越成就",
  "stats.l1": "卓越年限",
  "stats.l2": "全球目的地",
  "stats.l3": "快乐旅行者",
  "stats.l4": "客户评分",

  // Testimonials
  "testimonials.badge": "客户评价",
  "testimonials.title": "旅行者故事",
  "testimonials.subtitle": "听听数千名信任Arus Travel打造完美假期的快乐旅行者的心声。",
  "testimonials.readAll": "阅读全部评价",

  // CTA
  "cta.badge": "开始您的冒险",
  "cta.title": "您的梦想假期",
  "cta.titleLine2": "从这里开始",
  "cta.subtitle": "今天就与我们的旅游顾问交谈，让我们为您量身打造完美旅程。无需承诺，轻松简单 — 只有最好的旅行建议。",
  "cta.browse": "浏览全部旅游",
  "cta.consultation": "获取免费咨询",

  // Footer
  "footer.tagline": "您自2008年以来信赖的旅游伙伴。我们打造量身定制的难忘旅程，在每一步都提供卓越服务。",
  "footer.quickLinks": "快速链接",
  "footer.destinations": "目的地",
  "footer.contactUs": "联系我们",
  "footer.hours": "周一至周六：9:00am – 6:00pm",
  "footer.privacy": "隐私政策",
  "footer.terms": "条款与条件",
  "footer.d1": "东南亚旅游",
  "footer.d2": "东亚旅游",
  "footer.d3": "欧洲旅游",
  "footer.d4": "中东旅游",
  "footer.d5": "印度洋旅游",
  "footer.d6": "蜜月套餐",
};

export default translation;
